import { faAd, faBoltLightning, faCalculator, faCalendarCheck, faClock, faFileExport, faHashtag, faPlug, faSquareList, faUsers } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ConfigProvider, Menu, ThemeConfig } from "antd"
import { useContext } from "react"
import { useMatches, useNavigate } from "react-router-dom"
import { useBudgetYears } from "../../components/Budgets/budgetQueries"
import { useJobNumberingAvailable } from "../../domain/jobs/jobNumberingQueries"
import PageSidebar from "../../components/common/PageSidebar"
import { SetupContext } from "./SetupContext"

const SetupSidebar = () => {
  const navigate = useNavigate()
  const matches = useMatches()
  const selectedKey = matches[matches.length - 1].pathname
  const { hasChanges, markClean } = useContext(SetupContext)

  const budgetYearsQuery = useBudgetYears()
  const jobNumberingAvailable = useJobNumberingAvailable()
  const budgetYears = [...budgetYearsQuery.data ?? []].reverse()

  const theme: ThemeConfig = {
    components: {
      Menu: {
        darkItemBg: 'rgb(61, 88, 127)',
        darkSubMenuItemBg: 'rgb(61, 88, 127)',
        darkItemSelectedBg: 'rgb(74, 107, 154)',
        darkItemHoverBg: 'rgb(74, 107, 154)',
        darkItemColor: 'white',
        itemBorderRadius: 0,
        itemMarginInline: 0,
        itemMarginBlock: 0,
        itemPaddingInline: 4,
      }
    }
  }
  return <PageSidebar>
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <p style={{
        fontFamily: 'Open Sans, sans-serif',
        color: 'white',
        fontSize: 18,
        marginLeft: 24,
        marginTop: 24,
        marginBottom: 8,
      }}>System Setup</p>
      <div className="react-scrollable-list" style={{ flex: 1 }}>
        <ConfigProvider theme={theme}>
          <Menu
            mode="inline"
            defaultOpenKeys={['yearly-budgets', 'budget-worksheets', 'jobs', 'custom-lists', 'database', 'integrations']}
            selectedKeys={[selectedKey]}
            theme="dark"
            selectable={false}
            onClick={({ key }) => {
              if (hasChanges && !window.confirm('This section has been edited.\n\nDiscard your changes and select a different section?')) {
                return
              }
              markClean()
              navigate(key)
            }}
            items={[
              {
                key: 'yearly-budgets',
                label: 'Yearly Budgets',
                children: budgetYears.map(year => ({
                  key: `/budgets/${year}`,
                  label: year,
                  icon: <FontAwesomeIcon icon={faCalendarCheck} />,
                })) ?? [],
              },
              {
                key: 'budget-worksheets',
                label: 'Budget Worksheets',
                children: [
                  {
                    key: '/budget-worksheets',
                    label: 'Budget Worksheets',
                    icon: <FontAwesomeIcon icon={faCalculator} />,
                  },
                ]
              },
              ...(jobNumberingAvailable ? [{
                key: 'jobs',
                label: 'Jobs',
                children: [
                  {
                    key: '/job-numbering',
                    label: 'Job Numbering',
                    icon: <FontAwesomeIcon icon={faHashtag} />,
                  },
                ]
              }] : []),
              {
                key: 'custom-lists',
                label: 'Custom Lists',
                children: [
                  {
                    key: '/divisions',
                    label: 'Divisions',
                    icon: <FontAwesomeIcon icon={faSquareList} />,
                  },
                  {
                    key: '/crew-members',
                    label: 'Crew Members',
                    icon: <FontAwesomeIcon icon={faUsers} />,
                  },
                  {
                    key: '/cost-codes',
                    label: 'Cost Codes',
                    icon: <FontAwesomeIcon icon={faSquareList} />,
                  },
                  {
                    key: '/item-categories',
                    label: 'Item Categories',
                    icon: <FontAwesomeIcon icon={faSquareList} />,
                  },
                  {
                    key: '/sales-leads',
                    label: 'Sales Leads',
                    icon: <FontAwesomeIcon icon={faAd} />,
                  },
                  {
                    key: '/email-templates',
                    label: 'Email Templates',
                    icon: <FontAwesomeIcon icon={faSquareList} />,
                  },
                  {
                    key: '/unbillable-categories',
                    label: 'Unbillable Categories',
                    icon: <FontAwesomeIcon icon={faClock} />,
                  },
                ]
              },
              {
                key: 'database',
                label: 'Database',
                children: [
                  {
                    key: '/import-export',
                    label: 'Import & Export',
                    icon: <FontAwesomeIcon icon={faFileExport} />,
                  },
                ]
              },
              {
                key: 'integrations',
                label: 'Integrations',
                children: [
                  {
                    key: '/quickbooks',
                    label: 'QuickBooks',
                    icon: <FontAwesomeIcon icon={faPlug} />,
                  },
                  {
                    key: '/zapier-api-keys',
                    label: 'Zapier API Keys',
                    icon: <FontAwesomeIcon icon={faBoltLightning} />,
                  },
                ]
              }
            ]} />
        </ConfigProvider>
      </div>
    </div>
  </PageSidebar>
}

export default SetupSidebar
